import { IArticleTranslation } from '../interfaces/query/article-translation.query.interface';

export class ArticleTranslation {
    id: string;
    language: string;
    title: string;
    description: string;
    text: string;

    constructor(aritcleTranslationQuery?: IArticleTranslation) {
        if (aritcleTranslationQuery) {
            if (aritcleTranslationQuery.id) {
                this.id = aritcleTranslationQuery.id.toString();
            }
            this.language = aritcleTranslationQuery.language;
            this.title = aritcleTranslationQuery.title;
            this.description = aritcleTranslationQuery.description;
            this.text = aritcleTranslationQuery.text;
        }
    }
}
